import React from 'react'
import type { SystemStyleObject } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'

interface PageToolbarProps {
  leftElements?: React.ReactNode
  rightElements?: React.ReactNode
  sx?: SystemStyleObject
}

export const PageToolbar = ({ leftElements, rightElements, sx }: PageToolbarProps) => {
  return (
    <Box
      sx={{
        display: 'grid',
        w: '100%',
        gridTemplateColumns: { base: '1fr', lg: 'auto auto' },
        alignItems: 'center',
        justifyContent: 'space-between',
        rowGap: 4,
        ...sx,
      }}
    >
      <Box sx={{ order: { base: 1, lg: 0 } }}>
        {leftElements && leftElements}
      </Box>

      <Box sx={{ order: { base: 0, lg: 1 } }}>
        {rightElements && rightElements}
      </Box>
    </Box>
  )
}
